/**
 * Extended @react-navigation/native shim.
 *
 * Re-exports everything from the installed package and injects any exports
 * that newer @react-navigation/elements versions expect but the currently
 * installed @react-navigation/native may not yet provide.
 *
 * Uses a RELATIVE path to node_modules (not the package name) so webpack's
 * alias for '@react-navigation/native' is NOT applied here — avoiding an
 * infinite resolution loop.
 */
/* eslint-disable @typescript-eslint/no-require-imports */
const React = require('react');
// Relative path bypasses the webpack alias and goes straight to the package
const base = require('../../node_modules/@react-navigation/native');

module.exports = Object.assign({}, base, {
  // NavigationProvider was added in @react-navigation/native 7.x.
  // Provide a passthrough shim for older installed versions.
  NavigationProvider: base.NavigationProvider
    || function NavigationProvider({ children }) { return children; },
});
